/**
 * Combine states by zipCode
 * @param {String} zipString code
 * @return {String} name state.
 */
export function getState(zipString) {
  /* Ensure param is a string to prevent unpredictable parsing results */
  if (typeof zipString !== 'string') {
    console.error('Must pass the zipcode as a string.')
    return
  }

  /* Ensure we have exactly 5 characters to parse */
  if (zipString.length === 4) {
    console.error('Must pass a 5-digit zipcode.')
    zipString = `0${zipString}`
  }
  /* Ensure we have exactly 5 characters to parse */
  if (zipString.length !== 5) {
    console.error('Must pass a 5-digit zipcode.')
    return
  }

  /* Ensure we don't parse strings starting with 0 as octal values */
  const zipcode = parseInt(zipString, 10)

  let st

  /* Code cases alphabetized by state */
  if (zipcode >= 35000 && zipcode <= 36999) {
    st = 'al'
  } else if (zipcode >= 99500 && zipcode <= 99999) {
    st = 'ak'
  } else if (zipcode >= 85000 && zipcode <= 86999) {
    st = 'az'
  } else if (zipcode >= 71600 && zipcode <= 72999) {
    st = 'ar'
  } else if (zipcode >= 90000 && zipcode <= 96699) {
    st = 'ca'
  } else if (zipcode >= 80000 && zipcode <= 81999) {
    st = 'co'
  } else if (
    (zipcode >= 6000 && zipcode <= 6389) ||
    (zipcode >= 6391 && zipcode <= 6999)
  ) {
    st = 'ct'
  } else if (zipcode >= 19700 && zipcode <= 19999) {
    st = 'de'
  } else if (zipcode >= 32000 && zipcode <= 34999) {
    st = 'fl'
  } else if (
    (zipcode >= 30000 && zipcode <= 31999) ||
    (zipcode >= 39800 && zipcode <= 39999)
  ) {
    st = 'ga'
  } else if (zipcode >= 96700 && zipcode <= 96999) {
    st = 'hi'
  } else if (zipcode >= 83200 && zipcode <= 83999) {
    st = 'id'
  } else if (zipcode >= 60000 && zipcode <= 62999) {
    st = 'il'
  } else if (zipcode >= 46000 && zipcode <= 47999) {
    st = 'in'
  } else if (zipcode >= 50000 && zipcode <= 52999) {
    st = 'ia'
  } else if (zipcode >= 66000 && zipcode <= 67999) {
    st = 'ks'
  } else if (zipcode >= 40000 && zipcode <= 42999) {
    st = 'ky'
  } else if (zipcode >= 70000 && zipcode <= 71599) {
    st = 'la'
  } else if (zipcode >= 3900 && zipcode <= 4999) {
    st = 'me'
  } else if (zipcode >= 20600 && zipcode <= 21999) {
    st = 'md'
  } else if (
    (zipcode >= 1000 && zipcode <= 2799) ||
    zipcode == 5501 ||
    zipcode == 5544
  ) {
    st = 'ma'
  } else if (zipcode >= 48000 && zipcode <= 49999) {
    st = 'mi'
  } else if (zipcode >= 55000 && zipcode <= 56899) {
    st = 'mn'
  } else if (zipcode >= 38600 && zipcode <= 39999) {
    st = 'ms'
  } else if (zipcode >= 63000 && zipcode <= 65999) {
    st = 'mo'
  } else if (zipcode >= 59000 && zipcode <= 59999) {
    st = 'mt'
  } else if (zipcode >= 27000 && zipcode <= 28999) {
    st = 'nc'
  } else if (zipcode >= 58000 && zipcode <= 58999) {
    st = 'nd'
  } else if (zipcode >= 68000 && zipcode <= 69999) {
    st = 'ne'
  } else if (zipcode >= 88900 && zipcode <= 89999) {
    st = 'nv'
  } else if (zipcode >= 3000 && zipcode <= 3899) {
    st = 'nh'
  } else if (zipcode >= 7000 && zipcode <= 8999) {
    st = 'nj'
  } else if (zipcode >= 87000 && zipcode <= 88499) {
    st = 'nm'
  } else if (
    (zipcode >= 10000 && zipcode <= 14999) ||
    zipcode == 6390 ||
    zipcode == 501 ||
    zipcode == 544
  ) {
    st = 'ny'
  } else if (zipcode >= 43000 && zipcode <= 45999) {
    st = 'oh'
  } else if (
    (zipcode >= 73000 && zipcode <= 73199) ||
    (zipcode >= 73400 && zipcode <= 74999)
  ) {
    st = 'ok'
  } else if (zipcode >= 97000 && zipcode <= 97999) {
    st = 'or'
  } else if (zipcode >= 15000 && zipcode <= 19699) {
    st = 'pa'
  } else if (zipcode >= 300 && zipcode <= 999) {
    st = 'pr'
  } else if (zipcode >= 2800 && zipcode <= 2999) {
    st = 'ri'
  } else if (zipcode >= 29000 && zipcode <= 29999) {
    st = 'sc'
  } else if (zipcode >= 57000 && zipcode <= 57999) {
    st = 'sd'
  } else if (zipcode >= 37000 && zipcode <= 38599) {
    st = 'tn'
  } else if (
    (zipcode >= 75000 && zipcode <= 79999) ||
    (zipcode >= 73301 && zipcode <= 73399) ||
    (zipcode >= 88500 && zipcode <= 88599)
  ) {
    st = 'tx'
  } else if (zipcode >= 84000 && zipcode <= 84999) {
    st = 'ut'
  } else if (zipcode >= 5000 && zipcode <= 5999) {
    st = 'vt'
  } else if (
    (zipcode >= 20100 && zipcode <= 20199) ||
    (zipcode >= 22000 && zipcode <= 24699) ||
    zipcode == 20598
  ) {
    st = 'va'
  } else if (
    (zipcode >= 20000 && zipcode <= 20099) ||
    (zipcode >= 20200 && zipcode <= 20599) ||
    (zipcode >= 56900 && zipcode <= 56999)
  ) {
    st = 'dc'
  } else if (zipcode >= 98000 && zipcode <= 99499) {
    st = 'wa'
  } else if (zipcode >= 24700 && zipcode <= 26999) {
    st = 'wv'
  } else if (zipcode >= 53000 && zipcode <= 54999) {
    st = 'wi'
  } else if (zipcode >= 82000 && zipcode <= 83199) {
    st = 'wy'
  } else {
    st = 'none'
    console.error('No state found matching', zipcode)
  }

  return st
}
/**
 * Loop through the entire data array and combine values
 * @param {Array} data array of objects
 * @return {object} combined values.
 */
export const formatData = data => {
  return data.reduce(
    (acc, item, index) => {
      const state = getState(item.zipCode)

      if (!acc[state]) {
        acc[state] = {
          totalMailed: 0,
          totalMailedPercent: 0,
          totalEstimated: 0,
          totalEstimatedPercent: 0,
          resultsByDate: {},
        }
      }
      //Sum resultsByDate by State
      item.resultsByDate.nodes.forEach(({ date, amount }) => {
        if (index === 0) {
          acc.dates.push(date)
        }
        acc[state].resultsByDate[date]
          ? (acc[state].resultsByDate[date] += amount)
          : (acc[state].resultsByDate[date] = amount)
      })
      //Sum totalMailed by State
      acc[state].totalMailed += item.totalMailed
      //Sum totalMailedPercent by State
      acc[state].totalMailedPercent += item.totalMailedPercent
      //Sum totalMailedPercent by State
      acc[state].totalEstimated += item.totalEstimated
      //Sum totalEstimatedPercent by State
      acc[state].totalEstimatedPercent +=
        item.totalEstimatedPercent / data.length

      return acc
    },
    { dates: [] },
  )
}

/**
 * Convert value to arrays of arrays
 * @param {Array} data array of objects
 * @param {String} firstDate
 * @param {String} lastDate
 * @param {Array} Hash map returned formatData 'take a look at the previous function Except array of dates'
 * @return {Array} array of arrays format data
 */
export const dataToOptions = ({ data, firstDate, lastDate, hashMap }) =>
  data.map(item => [
    `us-${item}`,
    Math.ceil(
      ((hashMap[item].resultsByDate[lastDate] -
        hashMap[item].resultsByDate[firstDate]) /
        hashMap[item].totalMailed) *
        100,
    ),
  ])

export const renderMailDistributionGraphPopup = ({
  state,
  delivered,
  totalSentPercent,
  averageSpeed,
}) => `
                  <table>
                    <tr><td
                     style="text-align: center; color: #7C7C7C; padding-bottom: 11px;">${state}</td></tr>
                    <tr><td style="text-align: center; color: #7C7C7C;  border-top: 0.25px solid #B4B4B4; padding: 7px 58px 2px">Delivered - ${delivered}</td></tr>
                  <tr><td style="text-align: center; color: #7C7C7C;">Total sents - ${totalSentPercent}%</td></tr>
                  <tr><td style="text-align: center; color: #7C7C7C;">Avg mail speed - ${averageSpeed} BD</td></tr>
                  </table>
          `
/**
 * Convert color type HEX to RGBA
 * @param {string} hex color in hex
 * @param {number} opacity
 * @return {string} color in rgba.
 */
export const hexToRgbA = (hex, opacity) => {
  let color
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    color = hex.substring(1).split('')
    if (color.length == 3) {
      color = [color[0], color[0], color[1], color[1], color[2], color[2]]
    }
    color = `0x${color.join('')}`
    return `rgba(${[(color >> 16) & 255, (color >> 8) & 255, color & 255].join(
      ',',
    )} ,${opacity})`
  }
  throw new Error('Bad Hex')
}



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/Charts/MailDistributionGraph/utils.js